module.exports = __webpack_public_path__ + "img/watch-silver-2.35b01673.png";